module.exports = __webpack_public_path__ + "img/liste-soin-part-2.a6087d25.jpeg";